import bottomLeft from "../assets/images/icons/progress/bottom-left.svg";
import bottom from "../assets/images/icons/progress/bottom.svg";
import centerDown from "../assets/images/icons/progress/center-down.svg";
import centerUp from "../assets/images/icons/progress/center-up.svg";
import center from "../assets/images/icons/progress/center.svg";
import left from "../assets/images/icons/progress/left.svg";
import topRight from "../assets/images/icons/progress/top-right.svg";
import bottomRight from "../assets/images/icons/progress/bottom-right.svg"
import { useTranslation } from "./Localization";

export type ProgressIcon = "bottom-left" | "bottom" | "center-down" | "center-up" | "center" | "left" | "top-right" | "bottom-right";

const icons: Record<ProgressIcon, string> = {
  "bottom-left": bottomLeft,
  bottom,
  "center-down": centerDown,
  "center-up": centerUp,
  center,
  left,
  "top-right": topRight,
  "bottom-right": bottomRight
};

type ProgressProps = {
  step?: number;
  total?: number;
  gesture?: "none" | "up" | "down";
  icon?: ProgressIcon;
  showIcon?: boolean;
  showDots?: boolean;
};

export default function Progress({ step = 1, total = 3, gesture = "none", icon = "center", showIcon = true, showDots = true }: ProgressProps) {
  const { t } = useTranslation();
  return <div className={`progress${showDots ? "" : " progress-no-dots"}`} aria-label={t("accessibility.progress", { step, total })}>
    {showIcon && <span className={`qr qr-${gesture}`}><img src={icons[icon]} alt="" /></span>}
    {showDots && <div>{Array.from({ length: total }, (_, index) => index + 1).map((number) => <i key={number} className={number <= step ? "active" : ""} />)}</div>}
  </div>;
}
